import { render, staticRenderFns } from "./strategy-config.vue?vue&type=template&id=3b69f930"
import script from "./strategy-config.vue?vue&type=script&lang=ts"
export * from "./strategy-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports